module.exports = __webpack_public_path__ + "prod/20260811181522/img/url-app.d88da72d.png";